// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Box, Container as MuiContainer, styled, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

const Wrapper = styled(Box)({
  marginTop: 200
});

const Container = styled(MuiContainer)({});

const Cell = styled(Box)({
  padding: '38px 60px',
  height: '100%',
  background: '#CBDCDE',
  border: '1px solid #AFAFAF',
  borderRadius: '8px',

  '> ul': {
    padding: 0,
    'li > span': {
      color: '#E28C36'
    }
  }
});

function PrizePool() {
  return (
    <Wrapper>
      <Typography marginBottom={6} textAlign="center" variant="h1">
        Prize Pool
      </Typography>
      <Container>
        <Grid columns={{ xs: 4, sm: 8, lg: 12 }} container spacing={3}>
          <Grid lg={6} xl={6} xs={4}>
            <Cell>
              <img src="icon_box.webp" />
              <Typography variant="h2">For Every Participant:</Typography>
              <ul>
                <li>
                  <span>Credential</span> from zCloak
                </li>
                <li>
                  <span>OAT/POAP</span> from BuidlerDAO, Flock&Tusima, Mirror World, MoleDAO,
                  SnapFingerDAO, Web3Go.
                </li>
              </ul>
            </Cell>
          </Grid>
          <Grid lg={6} xl={6} xs={4}>
            <Cell>
              <img src="icon_winner.webp" />
              <Typography variant="h2">For Winners:</Typography>
              <ul>
                <li>
                  <span>$2000</span> from zCloak Network
                </li>
                <li>
                  5 Player Pass <span>NFT</span> Whitelist from Macondo
                </li>
              </ul>
            </Cell>
          </Grid>
        </Grid>
      </Container>
    </Wrapper>
  );
}

export default PrizePool;
